import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkFccId } from 'actions/model';
import { ProgressBar } from 'react-bootstrap';
import { Bubble } from 'ctia-ui';

class FCCID extends Component {
  componentDidMount() {
    const { checkFccId, match } = this.props;
    const fccId = match.params.id;
    checkFccId(fccId);
  }

  componentDidUpdate() {
    const { model } = this.props;

    if (model && model.gcode) {
      document.forms['fccCheck'].submit();
    }
  }

  renderPreloader() {
    return (
      <div>
        <h1>FCC ID</h1>
        <ProgressBar
          active
          now={100}
          label="Please wait. Querying the FCC database..."
        />
      </div>
    );
  }

  renderErrorMessage() {
    return (
      <div>
        <h1>FCC ID</h1>
        <Bubble type="danger">Wrong FCC ID passed.</Bubble>
      </div>
    );
  }

  render() {
    const { match, model } = this.props;
    const fccId = String(match.params.id);
    const modelFccGcode = model ? model.gcode : null;

    if (modelFccGcode === null) return this.renderPreloader();
    if (modelFccGcode === false) return this.renderErrorMessage();

    const gcode = modelFccGcode;
    const lengthDiff = fccId.length - gcode.length;
    const pcode = fccId.slice(-lengthDiff); // minus to slice from right
    return (
      <div>
        {this.renderPreloader()}
        <form
          action="https://apps.fcc.gov/oetcf/eas/reports/GenericSearchResult.cfm?RequestTimeout=30"
          method="post"
          name="fccCheck"
        >
          <input name="grantee_code" type="hidden" value={gcode} />
          <input name="product_code" type="hidden" value={pcode} />
          <input name="applicant_name" type="hidden" value="" />
          <input name="grant_date_from" type="hidden" value="" />
          <input name="grant_date_to" type="hidden" value="" />
          <input name="comments" type="hidden" value="" />
          <input name="application_purpose" type="hidden" value="" />
          <input
            name="application_purpose_description"
            type="hidden"
            value=""
          />
          <input name="grant_code_1" type="hidden" value="" />
          <input name="grant_code_2" type="hidden" value="" />
          <input name="grant_code_3" type="hidden" value="" />
          <input name="test_firm" type="hidden" value="" />
          <input name="equipment_class" type="hidden" value="" />
          <input name="equipment_class_description" type="hidden" value="" />
          <input name="lower_frequency" type="hidden" value="" />
          <input name="upper_frequency" type="hidden" value="" />
          <input name="bandwidth_from" type="hidden" value="" />
          <input name="emission_designator" type="hidden" value="" />
          <input name="tolerance_from" type="hidden" value="" />
          <input name="tolerance_to" type="hidden" value="" />
          <input name="power_output_from" type="hidden" value="" />
          <input name="power_output_to" type="hidden" value="" />
          <input name="rule_part_1" type="hidden" value="" />
          <input name="rule_part_2" type="hidden" value="" />
          <input name="rule_part_3" type="hidden" value="" />
          <input name="product_description" type="hidden" value="" />
          <input name="tcb_code" type="hidden" value="" />
          <input name="tcb_code_description" type="hidden" value="" />
          <input name="tcb_scope" type="hidden" value="" />
          <input name="tcb_scope_description" type="hidden" value="" />
          <input name="show_records" type="hidden" value="99" />
          <input name="fetchfrom" type="hidden" value="0" />
          <input name="calledFromFrame" type="hidden" value="N" />
        </form>
      </div>
    );
  }
}

function mapStateToProps({ model }) {
  return { model };
}

export default connect(
  mapStateToProps,
  { checkFccId }
)(FCCID);



// WEBPACK FOOTER //
// ./src/containers/FCCID.js